import { HTTP } from '@/utils';
import {
  SalesRepInterface,
  CreateSalesRepInterface,
  UpdateSalesRepInterface,
  PaginatedSalesRepParams,
} from '@/types/SalesRepInterface';

export default class SalesRepService {
  static resource_salesreps = 'salesreps';

  // GET all sales reps
  static async getSalesReps(): Promise<SalesRepInterface[]> {
    const response = await HTTP.get(`${this.resource_salesreps}`);
    return response.data.data;
  }

  // POST create a new sales rep
  static async createSalesRep(payload: CreateSalesRepInterface): Promise<CreateSalesRepInterface> {
    const response = await HTTP.post(`${this.resource_salesreps}`, payload);
    return response.data.data;
  }

  static async updateSalesRep(id: number, payload: Partial<UpdateSalesRepInterface>): Promise<SalesRepInterface> {
    const response = await HTTP.patch(`${this.resource_salesreps}/${id}`, payload);
    return response.data.data;
  }

  static async getPaginatedSalesReps(params: PaginatedSalesRepParams) {
    const response = await HTTP.get('/salesreps', { params });
    return response.data;
  }
}
